<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <div v-if="$gate.isSysAdmin()">
            <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h2>Status Lists | Master</h2>
                        </div>
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item">
                                    <a href="/home">Home</a>
                                </li>
                                <li class="breadcrumb-item active">
                                    {{ $route.meta.title }}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                <!-- /.container-fluid -->
            </section>

            <!-- Main content -->
            <section class="content">
                <br />
                <!-- main row for all icons  -->
                <div class="col-lg-12">
                    <div class="row">
                        <div class="col-lg-6 overflow-auto">
                            <div class="card card-danger card-outline">
                                <div class="card-header">Job Status</div>
                                <div class="card-body overflow-auto">
                                    <table
                                        class="table table-striped table-bordered table-hover"
                                    >
                                        <thead>
                                            <tr>
                                                <th>Status</th>
                                                <th>Validity</th>
                                                <th>Change</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="j in jobs" :key="j.id">
                                                <td>{{ j.status }}</td>
                                                <td>{{ j.validity }}</td>
                                                <td>
                                                    <button
                                                        class="btn btn-success fa fa-play"
                                                        v-if="
                                                            j.validity ==
                                                            'Inactive'
                                                        "
                                                        @click="
                                                            changeJob(
                                                                j.id,
                                                                'Active'
                                                            )
                                                        "
                                                    ></button>
                                                    <button
                                                        class="btn btn-danger fa fa-square"
                                                        v-else-if="
                                                            j.validity ==
                                                            'Active'
                                                        "
                                                        @click="
                                                            changeJob(
                                                                j.id,
                                                                'Inactive'
                                                            )
                                                        "
                                                    ></button>
                                                    <button
                                                        class="btn btn-danger fa fa-trash"
                                                        @click="
                                                            changeJob(
                                                                j.id,
                                                                'Deleted'
                                                            )
                                                        "
                                                    ></button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="card-footer">
                                    <div class="col-sm-12">
                                        <div class="row">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.status
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="jobstatus"
                                                    placeholder="Enter new status"
                                                />
                                                <span
                                                    v-if="errors.status"
                                                    :class="['badge bg-danger']"
                                                    >Please enter a valid
                                                    status.</span
                                                >
                                            </div>
                                            <div class="form-group">
                                                <button
                                                    class="btn btn-danger"
                                                    @click="addJob"
                                                >
                                                    <i class="fa fa-plus"></i>
                                                    Add Status
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 overflow-auto">
                            <div class="card card-danger card-outline">
                                <div class="card-header">
                                    Manage Delivery Status
                                </div>
                                <div class="card-body overflow-auto">
                                    <table
                                        class="table table-striped table-bordered table-hover"
                                    >
                                        <thead>
                                            <tr>
                                                <th>Status</th>
                                                <th>Validity</th>
                                                <th>Change</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="j in deliveries"
                                                :key="j.id"
                                            >
                                                <td>{{ j.status }}</td>
                                                <td>{{ j.validity }}</td>
                                                <td>
                                                    <button
                                                        class="btn btn-success fa fa-play"
                                                        v-if="
                                                            j.validity ==
                                                            'Inactive'
                                                        "
                                                        @click="
                                                            changeDelivery(
                                                                j.id,
                                                                'Active'
                                                            )
                                                        "
                                                    ></button>
                                                    <button
                                                        class="btn btn-danger fa fa-square"
                                                        v-else-if="
                                                            j.validity ==
                                                            'Active'
                                                        "
                                                        @click="
                                                            changeDelivery(
                                                                j.id,
                                                                'Inactive'
                                                            )
                                                        "
                                                    ></button>
                                                    <button
                                                        class="btn btn-danger fa fa-trash"
                                                        @click="
                                                            changeDelivery(
                                                                j.id,
                                                                'Deleted'
                                                            )
                                                        "
                                                    ></button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="card-footer">
                                    <div class="col-sm-12">
                                        <div class="row">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.status
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="deliverystatus"
                                                    placeholder="Enter new status"
                                                />
                                                <span
                                                    v-if="errors.status"
                                                    :class="['badge bg-danger']"
                                                    >Please enter a valid
                                                    status.</span
                                                >
                                            </div>
                                            <div class="form-group">
                                                <button
                                                    class="btn btn-danger"
                                                    @click="addDelivery"
                                                >
                                                    <i class="fa fa-plus"></i>
                                                    Add Status
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 overflow-auto">
                            <div class="card card-danger card-outline">
                                <div class="card-header">
                                    Installation Status
                                </div>
                                <div class="card-body overflow-auto">
                                    <table
                                        class="table table-striped table-bordered table-hover"
                                    >
                                        <thead>
                                            <tr>
                                                <th>Status</th>
                                                <th>Validity</th>
                                                <th>Change</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="j in installs"
                                                :key="j.id"
                                            >
                                                <td>{{ j.status }}</td>
                                                <td>{{ j.validity }}</td>
                                                <td>
                                                    <button
                                                        class="btn btn-success fa fa-play"
                                                        v-if="
                                                            j.validity ==
                                                            'Inactive'
                                                        "
                                                        @click="
                                                            changeInstall(
                                                                j.id,
                                                                'Active'
                                                            )
                                                        "
                                                    ></button>
                                                    <button
                                                        class="btn btn-danger fa fa-square"
                                                        v-else-if="
                                                            j.validity ==
                                                            'Active'
                                                        "
                                                        @click="
                                                            changeInstall(
                                                                j.id,
                                                                'Inactive'
                                                            )
                                                        "
                                                    ></button>
                                                    <button
                                                        class="btn btn-danger fa fa-trash"
                                                        @click="
                                                            changeInstall(
                                                                j.id,
                                                                'Deleted'
                                                            )
                                                        "
                                                    ></button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="card-footer">
                                    <div class="col-sm-12">
                                        <div class="row">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.status
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="installationstatus"
                                                    placeholder="Enter new status"
                                                />
                                                <span
                                                    v-if="errors.status"
                                                    :class="['badge bg-danger']"
                                                    >Please enter a valid
                                                    status.</span
                                                >
                                            </div>
                                            <div class="form-group">
                                                <button
                                                    class="btn btn-danger"
                                                    @click="addInstall"
                                                >
                                                    <i class="fa fa-plus"></i>
                                                    Add Status
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 overflow-auto">
                            <div class="card card-danger card-outline">
                                <div class="card-header">Audit Status</div>
                                <div class="card-body overflow-auto">
                                    <table
                                        class="table table-striped table-bordered table-hover"
                                    >
                                        <thead>
                                            <tr>
                                                <th>Status</th>
                                                <th>Validity</th>
                                                <th>Change</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="j in audits" :key="j.id">
                                                <td>{{ j.status }}</td>
                                                <td>{{ j.validity }}</td>
                                                <td>
                                                    <button
                                                        class="btn btn-success fa fa-play"
                                                        v-if="
                                                            j.validity ==
                                                            'Inactive'
                                                        "
                                                        @click="
                                                            changeAudit(
                                                                j.id,
                                                                'Active'
                                                            )
                                                        "
                                                    ></button>
                                                    <button
                                                        class="btn btn-danger fa fa-square"
                                                        v-else-if="
                                                            j.validity ==
                                                            'Active'
                                                        "
                                                        @click="
                                                            changeAudit(
                                                                j.id,
                                                                'Inactive'
                                                            )
                                                        "
                                                    ></button>
                                                    <button
                                                        class="btn btn-danger fa fa-trash"
                                                        @click="
                                                            changeAudit(
                                                                j.id,
                                                                'Deleted'
                                                            )
                                                        "
                                                    ></button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="card-footer">
                                    <div class="col-sm-12">
                                        <div class="row">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.status
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="auditstatus"
                                                    placeholder="Enter new status"
                                                />
                                                <span
                                                    v-if="errors.status"
                                                    :class="['badge bg-danger']"
                                                    >Please enter a valid
                                                    status.</span
                                                >
                                            </div>
                                            <div class="form-group">
                                                <button
                                                    class="btn btn-danger"
                                                    @click="addAudit"
                                                >
                                                    <i class="fa fa-plus"></i>
                                                    Add Status
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 overflow-auto">
                            <div class="card card-danger card-outline">
                                <div class="card-header">Gatepass Status</div>
                                <div class="card-body overflow-auto">
                                    <table
                                        class="table table-striped table-bordered table-hover"
                                    >
                                        <thead>
                                            <tr>
                                                <th>Status</th>
                                                <th>Validity</th>
                                                <th>Change</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="j in gpstatuses"
                                                :key="j.id"
                                            >
                                                <td>{{ j.status }}</td>
                                                <td>{{ j.validity }}</td>
                                                <td>
                                                    <button
                                                        class="btn btn-success fa fa-play"
                                                        v-if="
                                                            j.validity ==
                                                            'Inactive'
                                                        "
                                                        @click="
                                                            changeGPStatus(
                                                                j.id,
                                                                'Active'
                                                            )
                                                        "
                                                    ></button>
                                                    <button
                                                        class="btn btn-danger fa fa-square"
                                                        v-else-if="
                                                            j.validity ==
                                                            'Active'
                                                        "
                                                        @click="
                                                            changeGPStatus(
                                                                j.id,
                                                                'Inactive'
                                                            )
                                                        "
                                                    ></button>
                                                    <button
                                                        class="btn btn-danger fa fa-trash"
                                                        @click="
                                                            changeGPStatus(
                                                                j.id,
                                                                'Deleted'
                                                            )
                                                        "
                                                    ></button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="card-footer">
                                    <div class="col-sm-12">
                                        <div class="row">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.status
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="gpstatus"
                                                    placeholder="Enter new status"
                                                />
                                                <span
                                                    v-if="errors.status"
                                                    :class="['badge bg-danger']"
                                                    >Please enter a valid
                                                    status.</span
                                                >
                                            </div>
                                            <div class="form-group">
                                                <button
                                                    class="btn btn-danger"
                                                    @click="addGPStatus"
                                                >
                                                    <i class="fa fa-plus"></i>
                                                    Add Status
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 overflow-auto">
                            <div class="card card-danger card-outline">
                                <div class="card-header">Accessories</div>
                                <div class="card-body overflow-auto">
                                    <table
                                        class="table table-striped table-bordered table-hover"
                                    >
                                        <thead>
                                            <tr>
                                                <th>Accessory</th>
                                                <th>Change</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="j in accessories"
                                                :key="j.id"
                                            >
                                                <td>{{ j.accessory }}</td>
                                                <td>
                                                    <button
                                                        class="btn btn-success fa fa-play"
                                                        v-if="j.valid == 'No'"
                                                        @click="
                                                            changeAMode(
                                                                j.id,
                                                                'Yes'
                                                            )
                                                        "
                                                    ></button>
                                                    <button
                                                        class="btn btn-danger fa fa-square"
                                                        v-else-if="
                                                            j.valid == 'Yes'
                                                        "
                                                        @click="
                                                            changeAMode(
                                                                j.id,
                                                                'No'
                                                            )
                                                        "
                                                    ></button>
                                                    <!--<button class="btn btn-danger fa fa-trash"></button>-->
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <pagination
                                                :pagination="pagination"
                                                @prev="
                                                    getAccessories(
                                                        pagination.prevPageUrl
                                                    )
                                                "
                                                @next="
                                                    getAccessories(
                                                        pagination.nextPageUrl
                                                    )
                                                "
                                            ></pagination>
                                        </tfoot>
                                    </table>
                                </div>
                                <div class="card-footer">
                                    <div class="col-sm-12">
                                        <div class="row">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.accessory
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="accessory"
                                                    placeholder="Enter a new accessory"
                                                />
                                                <span
                                                    v-if="errors.accessory"
                                                    :class="['badge bg-danger']"
                                                    >Please enter a valid
                                                    accessory.</span
                                                >
                                            </div>
                                            <div class="form-group">
                                                <button
                                                    class="btn btn-danger"
                                                    @click="addAccessory"
                                                >
                                                    <i class="fa fa-plus"></i>
                                                    Add Accessory
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- row end -->
            </section>
            <!-- /.content -->

            <!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isSysAdmin()">
            <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
import Pagination from "../../pagination.vue";
export default {
    mounted() {
        console.log("Component mounted.");
    },

    created() {
        this.getJobs();
        this.getDeliveries();
        this.getLeads();
        this.getSales();
        this.getInstalls();
        this.getAudits();
        this.getAccessories();
        this.getGPStatuses();
    },

    components: { pagination: Pagination },

    data() {
        return {
            jobstatus: "",
            deliverystatus: "",
            leadstatus: "",
            salestatus: "",
            installationstatus: "",
            auditstatus: "",
            errors: [],
            jobs: [],
            deliveries: [],
            leads: [],
            sales: [],
            installs: [],
            audits: [],
            pagination: {
                lastPage: "",
                currentPage: "",
                total: "",
                lastPageUrl: "",
                nextPageUrl: "",
                prevPageUrl: "",
                from: "",
                to: "",
            },
            accessories: [],
            accessory: "",
            gpstatuses: [],
            gpstatus: "",
        };
    },

    methods: {
        configPagination(data) {
            this.pagination.lastPage = data.lastPage;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },

        addJob() {
            axios
                .post("/api/addJobStatus", { status: this.jobstatus })
                .then((response) => {
                    this.getJobs();
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                });
        },

        getJobs() {
            axios.post("/api/getJobStatuses").then((response) => {
                this.jobs = response.data;
            });
        },

        changeJob(id, status) {
            axios
                .post("/api/changeJobStatus", { id: id, status: status })
                .then((response) => {
                    this.getJobs();
                });
        },

        addDelivery() {
            axios
                .post("/api/addDeliveryStatus", { status: this.deliverystatus })
                .then((response) => {
                    this.getDeliveries();
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                });
        },

        getDeliveries() {
            axios.post("/api/getDeliveryStatuses").then((response) => {
                this.deliveries = response.data;
            });
        },

        changeDelivery(id, status) {
            axios
                .post("/api/changeDeliveryStatus", { id: id, status: status })
                .then((response) => {
                    this.getDeliveries();
                });
        },

        addLead() {
            axios
                .post("/api/addLeadStatus", { status: this.leadstatus })
                .then((response) => {
                    this.getLeads();
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                });
        },

        getLeads() {
            axios.post("/api/getLeadStatuses").then((response) => {
                this.leads = response.data;
            });
        },

        changeLead(id, status) {
            axios
                .post("/api/changeLeadStatus", { id: id, status: status })
                .then((response) => {
                    this.getLeads();
                });
        },

        addSale() {
            axios
                .post("/api/addSaleStatus", { status: this.salestatus })
                .then((response) => {
                    this.getSales();
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                });
        },

        getSales() {
            axios.post("/api/getSaleStatuses").then((response) => {
                this.sales = response.data;
            });
        },

        changeSale(id, status) {
            axios
                .post("/api/changeSaleStatus", { id: id, status: status })
                .then((response) => {
                    this.getSales();
                });
        },

        addInstall() {
            axios
                .post("/api/addInstallStatus", {
                    status: this.installationstatus,
                })
                .then((response) => {
                    this.getInstalls();
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                });
        },

        getInstalls() {
            axios.post("/api/getInstallStatuses").then((response) => {
                this.installs = response.data;
            });
        },

        changeInstall(id, status) {
            axios
                .post("/api/changeInstallStatus", { id: id, status: status })
                .then((response) => {
                    this.getInstalls();
                });
        },

        addAudit() {
            axios
                .post("/api/addAuditStatus", { status: this.auditstatus })
                .then((response) => {
                    this.getAudits();
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                });
        },

        getAudits() {
            axios.post("/api/getAuditStatuses").then((response) => {
                this.audits = response.data;
            });
        },

        changeAudit(id, status) {
            axios
                .post("/api/changeAuditStatus", { id: id, status: status })
                .then((response) => {
                    this.getAudits();
                });
        },

        addGPStatus() {
            axios
                .post("/api/addGPStatus", { status: this.gpstatus })
                .then((response) => {
                    this.getGPStatuses();
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                });
        },

        getGPStatuses() {
            axios.post("/api/getAllGPStatuses").then((response) => {
                this.gpstatuses = response.data;
            });
        },

        changeGPStatus(id, status) {
            axios
                .post("/api/changeGPStatus", { id: id, status: status })
                .then((response) => {
                    this.getGPStatuses();
                });
        },

        addAccessory() {
            axios
                .post("/api/addAccessory", { accessory: this.accessory })
                .then((response) => {
                    this.getAccessories();
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                });
        },

        getAccessories() {
            axios.post("/api/getAccessories").then((response) => {
                this.accessories = response.data.data.data;
                this.configPagination(response.data.data);
            });
        },

        changeAMode(id, status) {
            axios
                .post("/api/changeAMode", { id: id, status: status })
                .then((response) => {
                    this.getAccessories();
                });
        },
    },
};
</script>
